import i18n from '@/plugins/i18n'

export enum SortTypes {
  NameDescending = 'a-to-z',
  NameAscending = 'z-to-a',
  DateDescending = 'newer',
  DateAscending = 'oldest',
}

export type SortType =
  | ''
  | SortTypes.DateDescending
  | SortTypes.DateAscending
  | SortTypes.NameDescending
  | SortTypes.NameAscending

export const sortOptions = [
  // eslint-disable-next-line
  // @ts-ignore
  { name: i18n.global.t('None'), value: '' },
  { name: i18n.global.t('Newer'), value: SortTypes.DateDescending },
  { name: i18n.global.t('Oldest'), value: SortTypes.DateAscending },
]
